module.exports = __webpack_public_path__ + "img/EGIFTEE.68aaa181.png";